import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Equalizer from "@mui/icons-material/Equalizer";

// core components
import Grid from "@mui/material/Grid";

import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, OpcionSiNoEntero, PopUpResult, TipoOthelloFieldGrid} from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit  from '../componentsothello/OthelloEdit.jsx';
import OthelloTimer from "../componentsothello/OthelloTimer.jsx";


import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloCheckBox from "../componentsothello/OthelloCheckBox.jsx";
import OthelloTitulo from "../componentsothello/OthelloTitulo.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";

export default function TramosReservas({ ...props }) {
    const { literal, idRol, tipooficina } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [datatramos, setdatatramos] = React.useState(null);
    const [datainstalaciones, setdatainstalaciones] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [diasCerrando, setdiasCerrando] = useState(null);

    const navigate = useNavigate();

    const location = useLocation();

    React.useEffect(() => {

        setLoading(false);
        getDataPageIniciales();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPageIniciales = () => {

        fetch('api/Data/GetInstalacionesReserva')
            .then(response => response.json())
            .then(data => {

                let restramos = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.id_Instalacion,
                        name: x.descripcion
                    };

                    return val;

                })

                setdatainstalaciones(restramos);

                getDataPage();
            });
    }

    const getDataPage = () => {
        fetch('api/Data/GetTramosReserva')
            .then(response => response.json())
            .then(data => {
                setdatatramos(data);
            });
    }

    const getDataVaciaTramo = () => {
        fetch('api/Data/GetTramoReservaVacio')
            .then(response => response.json())
            .then(data => {
                setdataeditando(data);
                setdiasCerrando(data.diasCerrado);
                setstatePage(DataStatePage.dsInsert);

            }).catch(error => {
                setdataeditando(null);
                setdiasCerrando("");
            });
    }

    const grabarDataPageTramo = (event) => {

        //Altero el valor que tiene el input de dias visualizando
        try {
            //refs.form[2].value = diasCerrando;
        }
        catch { }

        let formulario = document.getElementById('formtramos');
        let formData = new FormData(formulario);

        var object = {};
        formData.forEach((value, key) => { object[key] = value });
        if (object != null) {
        }

        fetch('api/Data/GrabarReservaTramo', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {


            if (indexeditando == -1) {

                var array = [...datatramos];
                array.push(res);
                setdatatramos(array);
            }
            else {
                var array = [...datatramos];
                array[indexeditando] = res;
                setdatatramos(array);
            }

            setdiasCerrando(res.diasCerrado);
            setdataeditando(null);
            setindexeditando(null);
            setstatePage(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageTramo = () => {
        getDataVaciaTramo();
        setindexeditando(-1);
        setdiasCerrando("");
    }

    const buscarDataPageTramo = () => {
        setdataeditando(null);
        setindexeditando(null);
        setstatePage(DataStatePage.dsSearch);
    }

    const cancelarDataPageTramo = () => {
        setdataeditando(null);
        setindexeditando(null);
        setdiasCerrando("");
        setstatePage(DataStatePage.dsSearch);
    }

    const deshacerDataPageTramo = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1)
            setstatePage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        else {

            if (dataeditando != null)
                setdiasCerrando(dataeditando.diasCerrado);

            //forceUpdate();
        }
    }

    //METODO SOBRE EL GRID    
    const editGridDataPageTramo = (valor, index) => {

        setdataeditando(valor);
        setindexeditando(index);
        setdiasCerrando(valor.diasCerrado);
        setstatePage(DataStatePage.dsEdit);
    }

    const deleteGridDataPageTramo = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Tramo);

            fetch('api/Data/EliminarTramoReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);

                    if (datatramos != null) {
                        var array = [...datatramos]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdatatramos(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const onChangeDiaCheckBox = (id, valor) => {

        //Si tenemo valor editando
        if (dataeditando != null && diasCerrando != null) {
            let dias = diasCerrando;

            //Si me dice que se ha seleccionado el check
            if (valor) {

                //Si no esta dentro de los dias a visualizar
                if (dias.indexOf(id) < 0) {
                    dias = dias + id;
                }
            }
            //sino, es que debemos eliminarlo
            else {
                dias = dias.replace(id, "");
            }

            setdiasCerrando(dias);
        }
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearchTramos(datos) {

        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Tramo", "Instalacion", "Codigo", "Descripcion", "Pax"];

        let valoreshow = ["id_Tramo", "id_Instalacion", "codigo", "descripcion", "pax"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "id_Instalacion", items: datainstalaciones });


        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onEdit={editGridDataPageTramo} onDelete={deleteGridDataPageTramo} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEditTramos(Tramo) {

        if (Tramo != null) {
            let Nombre = Tramo != null && Tramo.id_Tramo > 0 ? "Editar " + Tramo.codigo : "Nuevo Tramo";

            return (<OthelloTituloPanelData icon="equalizer" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageTramo} onGrabar={grabarDataPageTramo} onCancel={cancelarDataPageTramo} onDeshacer={deshacerDataPageTramo} />
                        </Grid>
                    </Grid>
                    <form id="formtramos" >
                        <Grid container>
                            <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={Tramo.id_Oficina} />
                            <input id="Id_Tramo" name="Id_Tramo" type="hidden" value={Tramo.id_Tramo} />
                            <input id="diasCerrado" name="diasCerrado" type="hidden" value={diasCerrando} />
                            <Grid item xs={6} sm={4} lg={2}>
                                <OthelloEdit label="Codigo" fieldname="Codigo" currentvalue={Tramo.codigo} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={3}>
                                <OthelloEdit label="Descripcion" fieldname="Descripcion" currentvalue={Tramo.descripcion} />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={3}>
                                <OthelloComboBox label='Instalacion' fieldname="Id_Instalacion" items={datainstalaciones} currentvalue={Tramo.id_Instalacion} />
                            </Grid>
                            <Grid item xs={4} sm={6} lg={2}>
                                <OthelloTimer label="Hora Inicio (00:00 ModoHorario)" fieldname="HoraIni" currentvalue={Tramo.horaIni} tipo="time" />
                            </Grid>
                            <Grid item xs={4} sm={6} lg={2}>
                                <OthelloTimer label="Hora Fin (00:00 ModoHorario)" fieldname="HoraFin" currentvalue={Tramo.horaFin} tipo="time" />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6} sm={4} lg={2}>
                                <OthelloEdit label="Fin Acesso(Mins Previos)" fieldname="FinAcceso" currentvalue={Tramo.finAcceso} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={2}>
                                <OthelloEdit label="Pax Tramo (Cupo)" fieldname="Pax" currentvalue={Tramo.pax} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Maximo Pax Por Reseva" fieldname="MaxPaxReservar" currentvalue={Tramo.maxPaxReservar} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Precio (o 24h)" fieldname="Precio" currentvalue={Tramo.precio} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Precio Reducido (o 24h)" fieldname="PrecioReducido" currentvalue={Tramo.precioReducido} />
                            </Grid>
                            {/*Para que salga la opcion de plazas que van a ser con precio 0*/}
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloComboBox label='Gratuidades' fieldname="ConPrecioCero" items={OpcionSiNoEntero} currentvalue={Tramo.conPrecioCero} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloComboBox label='Es Precio Global (No precio x pax)' fieldname="EsPrecioGlobal" items={OpcionSiNoEntero} currentvalue={Tramo.esPrecioGlobal} />
                            </Grid>                            
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Orden" fieldname="ordenVisual" currentvalue={Tramo.ordenVisual} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Row/PosX" fieldname="row" currentvalue={Tramo.row} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Col/PosY" fieldname="col" currentvalue={Tramo.col} />
                            </Grid>
                            <Grid item xs={6} sm={4} lg={3}>
                                <OthelloEdit label="Filtrado Extras (Vacio = todosOk ,Filtrar ej: id_extra1|id2|id3)" fieldname="extras" currentvalue={Tramo.extras} />
                            </Grid>                                                   
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                <OthelloEdit label="Informacion Precios" fieldname="InfoPrecios" currentvalue={Tramo.infoPrecios} rows={3} />
                            </Grid>
                        </Grid>
                         <Grid container>
                            <Grid item xs={12} lg={12}>
                                <br />
                                <OthelloTitulo titulo="Instalacion Tipo Horaria" backgroundColor="#709e86" />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6} sm={4} lg={1}>
                                <OthelloEdit label="Precio Hora" fieldname="PrecioHora" currentvalue={Tramo.precioHora} />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={1}>
                                <OthelloEdit label="Items Horas" fieldname="ItemsHoraria" currentvalue={Tramo.itemsHoraria} />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={2}>
                                <OthelloEdit label="Periocidad Horas (NumHoras) " fieldname="PeriocidadHoraria" currentvalue={Tramo.periocidadHoraria} />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={2}>
                                <OthelloEdit label="ID Cerradura Horaria" fieldname="ID_CerraduraHoraria" currentvalue={Tramo.iD_CerraduraHoraria} />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={2}>
                                <OthelloComboBox label='Item 24 horas' fieldname="Item24horas" items={OpcionSiNoEntero} currentvalue={Tramo.item24horas} />                                
                            </Grid>
                            <Grid item xs={12} sm={4} lg={2}>
                                <OthelloComboBox label='Opcion Any Hora' fieldname="OpcionAnyHora" items={OpcionSiNoEntero} currentvalue={Tramo.opcionAnyHora} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <br />
                                <OthelloTitulo titulo="Dias Tramo Cerrado" backgroundColor="#709e86" />
                            </Grid>
                        </Grid>
                        <Grid container xs={10}>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Lunes" fieldname="L" checked={diasCerrando != null && diasCerrando.indexOf("L") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Martes" fieldname="M" checked={diasCerrando != null && diasCerrando.indexOf("M") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} lg={1.5} >
                                <OthelloCheckBox label="Miercoles" fieldname="X" checked={diasCerrando != null && diasCerrando.indexOf("X") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Jueves" fieldname="J" checked={diasCerrando != null && diasCerrando.indexOf("J") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Viernes" fieldname="V" checked={diasCerrando != null && diasCerrando.indexOf("V") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Sabado" fieldname="S" checked={diasCerrando != null && diasCerrando.indexOf("S") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Domingo" fieldname="D" checked={diasCerrando != null && diasCerrando.indexOf("D") >= 0} onChange={onChangeDiaCheckBox} />
                            </Grid>
                        </Grid>
                        <br />
                    </form>
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    let busquedaTramos = loading ? <p><CircularProgress color="secondary" /></p> : renderSearchTramos(datatramos)

    let edicionTramos = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEditTramos(dataeditando) : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    {alerta}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    {edicionTramos}
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageTramo} forzarnuevo={true} />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData tituloliteral= "_tramosreservas" margentop={0}>
                        <Grid container>
                            <Grid item xs={12}>
                                {busquedaTramos}
                            </Grid>
                        </Grid>
                    </OthelloTituloPanelData>
                </Grid>                
            </Grid>
        </Grid>
    );
}

